/** 旅行安全风险展示。内部码仍是 extreme / high / medium / low。 */
export type TravelRiskLevel = 'extreme' | 'high' | 'medium' | 'low'

export interface TravelRiskDisplay {
  colorName: string
  /** 角标、筛选项 */
  short: string
  /** 标题标签：红色 · 暂勿前往 */
  tag: string
  /** 图例标题 */
  legend: string
  /** 固定安全提醒，只展示，不写回接口 */
  advice: string
  fill: string
  onFill: string
  /** 浅底上的字色 */
  text: string
  bg: string
  shadow: string
}

export const TRAVEL_RISK_LEVELS: TravelRiskLevel[] = ['extreme', 'high', 'medium', 'low']

export const TRAVEL_RISK_DISPLAY: Record<TravelRiskLevel, TravelRiskDisplay> = {
  extreme: {
    colorName: '红色',
    short: '暂勿前往',
    tag: '红色 · 暂勿前往',
    legend: '红色 · 暂勿前往',
    advice: '外交部提醒中国公民近期暂勿前往',
    fill: '#DC2626',
    onFill: '#FEE2E2',
    text: '#DC2626',
    bg: '#FEF2F2',
    shadow: 'rgba(220, 38, 38, 0.45)',
  },
  high: {
    colorName: '橙色',
    short: '谨慎前往',
    tag: '橙色 · 谨慎前往',
    legend: '橙色 · 谨慎前往',
    advice: '外交部提醒中国公民近期谨慎前往',
    fill: '#F97316',
    onFill: '#1C1917',
    text: '#C2410C',
    bg: '#FFF7ED',
    shadow: 'rgba(249, 115, 22, 0.4)',
  },
  medium: {
    colorName: '黄色',
    short: '密切关注',
    tag: '黄色 · 密切关注',
    legend: '黄色 · 密切关注',
    advice: '密切关注当地安全形势，提高警惕，加强防范，注意安全',
    fill: '#EAB308',
    onFill: '#1C1917',
    text: '#A16207',
    bg: '#FEFCE8',
    shadow: 'rgba(234, 179, 8, 0.45)',
  },
  low: {
    colorName: '蓝色',
    short: '无提醒',
    tag: '蓝色 · 无提醒',
    legend: '蓝色 · 无提醒',
    advice: '无相关安全提醒',
    fill: '#3B82F6',
    onFill: '#EFF6FF',
    text: '#1D4ED8',
    bg: '#EFF6FF',
    shadow: 'rgba(59, 130, 246, 0.4)',
  },
}

/** 列表、树、标签上的等级名 */
export const TRAVEL_RISK_TAG: Record<TravelRiskLevel, string> = {
  extreme: TRAVEL_RISK_DISPLAY.extreme.tag,
  high: TRAVEL_RISK_DISPLAY.high.tag,
  medium: TRAVEL_RISK_DISPLAY.medium.tag,
  low: TRAVEL_RISK_DISPLAY.low.tag,
}

export const RISK_LEVEL_GUIDE_TITLE = '境外安全风险等级'

export const RISK_LEVEL_GUIDE_FOOT =
  '请登录中国领事服务网或使用「中国领事」APP 查看所在国家风险等级和安全提醒。'

export function travelRiskDisplay(
  level: TravelRiskLevel | string | null | undefined,
): TravelRiskDisplay {
  if (level === 'extreme' || level === 'high' || level === 'medium' || level === 'low') {
    return TRAVEL_RISK_DISPLAY[level]
  }
  return TRAVEL_RISK_DISPLAY.low
}
